import 'assets/scss/components/maincontentheader.scss';
import { useState, useRef, useContext } from 'react';
import expertModeImage from 'assets/img/expert-mode.jpg';
import Modal from 'react-bootstrap/Modal';
import { EmbedSiteShortContext } from 'App.js';

export default function ExpertButton({ isExpertMode, forceEasyMode, handleExpertModeToggle, showExpertModeModal, handleExpertModeModalToggle, settings })
{
    const site = useContext(EmbedSiteShortContext);

    //#region Event handlers
    const handleExpertToggle = () => {
        handleExpertModeToggle();
        handleExpertModeModalToggle();
    }

    const fromSwitch = useRef(false);

    const openExpertModeModal = () => {
        fromSwitch.current = true;
        handleExpertModeModalToggle();
    }

    const closeExpertModeModal = () => {
        if (fromSwitch.current) {
            openModalSwitch.current.click();
            fromSwitch.current = false;
        }

        handleExpertModeModalToggle();
    }

    //#endregion Event Handlers

    const [showLeavingModal, setShowLeavingModal] = useState(false);

    const handleLeavingModalClose = () => {
        setShowLeavingModal(false);
    }

    const openModalSwitch = useRef(null);

    return (
        <>

            <div className="form-check form-switch header-expert-mode d-flex align-items-center ms-auto">
                <input className={"form-check-input header-expert-toggle-icon me-2" + (isExpertMode === true ? " checked " : "")}
                    type="checkbox" role="switch" id="flexSwitchCheckDefault"
                    disabled={isExpertMode === true || forceEasyMode === true ? "disabled" : ""}
                    onClick={openExpertModeModal} ref={openModalSwitch}
                />
                <label className="form-check-label text-casing" htmlFor="flexSwitchCheckDefault">Expert<span className="expert-mode-display"> Mode</span></label>
            </div>

            {/*Expert Mode notice modal*/}
            <Modal className={site + "-modal notice-modal"} show={showExpertModeModal} onHide={() => { handleLeavingModalClose() }} backdrop="static" keyboard={false}>
                <Modal.Body style={site === "chillblast" ? { backgroundColor: "#212529" } : {}}>
                    <div className="modal-content border-0">
                        <div className="modal-body border-bottom-0 p-3 d-flex" style={site === "chillblast" ? { backgroundColor: "#212529" } : {}}>
                            <div className="modal-body-left-container pe-1">
                                <img src={process.env.REACT_APP_ASSET_BASE_URL + expertModeImage} className="main-prebuilt-image w-auto" width="356" height="464"></img>
                            </div>
                            <div className="modal-body-right-container">
                                <div className="close-button-container">
                                    <button type="button" className="btn-close close-button float-end" data-bs-dismiss="modal" aria-label="Close" onClick={closeExpertModeModal}></button>
                                </div>
                                <div className="px-sm-4">
                                    <label className="top-label text-muted text-casing mb-3 fw-bold">Expert Mode</label>
                                    <h1 className="title mb-4" style={site === "chillblast" ? { color: "#f8f9fa" } : {}}>Are you sure you want to enable 'Expert Mode'?</h1>
                                    <h5 className="message mb-4" style={site === "chillblast" ? { color: "rgba(222, 226, 230, 0.75)" } : {}}>You cannot undo this once active without restarting the build process. Expert Mode allows you to see additional options for your custom PC.</h5>

                                    <div className="action-buttons-container">
                                        <button type="button" className="yes-button primary-button text-casing d-block w-100 py-3 mb-2" style={site === "chillblast" ? { color: "#212529" } : {}} onClick={handleExpertToggle} >Yes, enable expert mode</button>
                                        <button type="button" className="no-button white-button text-casing d-block w-100 py-3" style={ site === "chillblast" ? { backgroundColor: "#212529", color: "rgba(222, 226, 230, 0.75)"} : {}} onClick={closeExpertModeModal} >No, go back</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    );
}